export class utils {
    static GetDetails (archingDetails, defaultCurrency) {
        let auxDetails = [];
        Object
            .keys(archingDetails)
            .forEach((type) => {
                auxDetails = auxDetails.concat(this.MapDetailCard(archingDetails, type, defaultCurrency));
            });
        
        return auxDetails
            .filter(item => item.cashType !== "Cash" || item.total > 0);
    }
    
    static MapDetailCard (archingDetails, type, defaultCurrency) {
        if (type === "Card" && archingDetails[type]?.cards) {
            const resu = [];
            archingDetails[type].cards.forEach((card) => {
                resu.push(
                    {
                        cashType: "Card",
                        currency: defaultCurrency,
                        total: card.subType?.Sale?.total || 0,
                        real: Number(card.subType?.Sale?.realTotal) || 0,
                        count: Number(card.subType?.Sale?.realCount) || 0,
                        subType: "Sale",
                        cashTypeId: card?.id
                    },
                    {
                        cashType: "Card",
                        currency: defaultCurrency,
                        total: card.subType?.Refund?.total || 0,
                        real: Number(card.subType?.Refund?.realTotal) || 0,
                        count: Number(card.subType?.Refund?.realCount) || 0,
                        subType: "Refund",
                        cashTypeId: card?.id
                    },
                    {
                        cashType: "Card",
                        currency: defaultCurrency,
                        total: card.subType?.Void?.total || 0,
                        real: Number(card.subType?.Void?.realTotal) || 0,
                        count: Number(card.subType?.Void?.realCount) || 0,
                        subType: "Void",
                        cashTypeId: card?.id
                    }
                )
            });
            return resu;
        } else if (type.startsWith("Cash")) {
            const curr = type.substring("Cash".length);
            return [{
                cashType: "Cash",
                currency: curr,
                currencyPrice: archingDetails[type].currencyPrice,
                total: archingDetails[type].total || 0,
                real: Number(archingDetails[type].real) || 0,
                openingAmount: Number(archingDetails[type].lastClosureAmount) || 0,
                subType: "Sale",
                count: 0
            }]
        } else {
            return [{
                cashType: type,
                currency: defaultCurrency,
                total: archingDetails[type].total || 0,
                real: Number(archingDetails[type].real) || 0,
                openingAmount: Number(archingDetails[type].lastClosureAmount) || 0,
                subType: "Sale",
                count: 0
            }]
        }
    }
}